import { OutputEmitterRef, Type } from '@angular/core';

import type { ZodType } from 'zod';

import { createProviderToken } from '@core/common-legacy';

export interface InterruptRenderer<T = unknown, R = unknown> {
  readonly reason: string;
  readonly schema: ZodType<T>;
  readonly component: Type<{
    payload: T;
    resolve: OutputEmitterRef<R>;
    cancel?: OutputEmitterRef<void>;
  }>;
}

export const { provide: provideTellentInterruptRenderer, inject: injectTellentInterruptRenderers } =
  createProviderToken<InterruptRenderer>('TELLENT_INTERRUPT_RENDERERS')(true);
